(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brand-footer"] && !Shopify.designMode) return;
  try {
    
  // "Cookie preferences" reopens Shopify's cookie banner. Shown only when the banner's script offers it
  // (it loads after the page), checked a few times, so the button never appears without doing anything.
  (() => {
    const item = document.querySelector('.brand-footer__cookie');
    if (!item) return;
    let tries = 0;
    const check = () => {
      if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
        item.hidden = false;
        item.querySelector('[data-cookie-preferences]').addEventListener('click', () => window.privacyBanner.showPreferences());
      } else if (tries++ < 10) {
        setTimeout(check, 1000);
      }
    };
    if (document.readyState === 'complete') check();
    else window.addEventListener('load', check);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["expect"] && !Shopify.designMode) return;
  try {
    
  // Scroll story (desktop): the benefit under the middle of the screen becomes active and its
  // photo fades in. On the mobile card scroll the photo frame is hidden, so nothing runs.
  class ExpectStory extends HTMLElement {
    connectedCallback() {
      this.items = [...this.querySelectorAll('.expect__item')];
      this.images = [...this.querySelectorAll('.expect__media .expect__image')];
      this.mediaWrap = this.querySelector('.expect__media-wrap');
      if (!this.items.length) return;

      this.activate(this.items[0]);
      this.observer = new IntersectionObserver(
        (entries) => {
          if (!this.mediaWrap.offsetParent) return;
          entries.forEach((entry) => {
            if (entry.isIntersecting) this.activate(entry.target);
          });
        },
        { rootMargin: '-50% 0px -50% 0px' }
      );
      this.items.forEach((item) => this.observer.observe(item));

      // Theme editor: selecting a benefit block shows its photo
      this.onBlockSelect = (event) => {
        const item = this.items.find((entry) => entry === event.target || entry.contains(event.target));
        if (item) this.activate(item);
      };
      document.addEventListener('shopify:block:select', this.onBlockSelect);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
    }

    activate(target) {
      this.items.forEach((item) => item.classList.toggle('is-active', item === target));
      const index = Number(target.dataset.media) || 0;
      this.images.forEach((image, i) => image.classList.toggle('is-active', i === index));
    }
  }

  customElements.define('expect-story', ExpectStory);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["formula"] && !Shopify.designMode) return;
  try {
    
  // The formula: the pillar row filters the ingredient list (one pillar at a time; pressing it again,
  // or All, shows everything). The list keeps its full height while filtered, so the page never jumps;
  // cards fade out, the rest glide into place and the new ones fade in (opacity and transform only).
  // It also switches the ingredients between open cards (wide) and short rows that open (narrow),
  // following --formula-mode from the container query.
  class FormulaFilter extends HTMLElement {
    connectedCallback() {
      this.chips = [...this.querySelectorAll('.formula__chip')];
      this.items = [...this.querySelectorAll('.formula__ingredient')];
      this.list = this.querySelector('.formula__list');
      this.status = this.querySelector('[data-formula-status]');
      this.current = 'all';
      this.mode = null;
      this.run = 0;

      this.chips.forEach((chip) => {
        chip.addEventListener('click', () => {
          const key = chip.dataset.filter;
          this.select(key === this.current ? 'all' : key);
        });
      });

      this.addEventListener('click', (event) => {
        if (this.mode === 'list' && event.target.closest('.formula__summary')) event.preventDefault();
      });

      this.resizeObserver = new ResizeObserver(() => this.updateMode());
      this.resizeObserver.observe(this);

      // Theme editor: selecting a pillar block filters by it; selecting an ingredient shows it, open
      this.onBlockSelect = (event) => {
        const chip = this.chips.find((item) => item === event.target);
        if (chip) return this.select(chip.dataset.filter);
        const item = this.items.find((entry) => entry === event.target || entry.contains(event.target));
        if (item) {
          if (item.hidden) this.select('all');
          item.querySelector('details').open = true;
        }
      };
      document.addEventListener('shopify:block:select', this.onBlockSelect);
    }

    disconnectedCallback() {
      this.resizeObserver?.disconnect();
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
    }

    updateMode() {
      const mode = getComputedStyle(this).getPropertyValue('--formula-mode').trim() || 'list';
      if (mode === this.mode) return;
      this.mode = mode;
      this.items.forEach((item) => {
        const details = item.querySelector('details');
        const summary = details.querySelector('summary');
        details.open = mode === 'list';
        if (mode === 'list') summary.setAttribute('tabindex', '-1');
        else summary.removeAttribute('tabindex');
      });
      if (this.current !== 'all') this.list.style.minHeight = '';
      this.reserved = false;
    }

    matches(item, key) {
      return key === 'all' || item.dataset.pillars.split(' ').includes(key);
    }

    async select(key) {
      if (key === this.current) return;
      const run = ++this.run;
      // A new choice cancels the previous one's animations (an interrupted fade-out would stay at 0)
      this.items.forEach((item) => item.getAnimations().forEach((animation) => animation.cancel()));

      this.chips.forEach((chip) => chip.setAttribute('aria-pressed', String(chip.dataset.filter === key)));

      // Keep the list at its full height while filtered
      if (this.current === 'all') this.list.style.minHeight = `${this.list.getBoundingClientRect().height}px`;
      this.current = key;

      const leaving = this.items.filter((item) => !item.hidden && !this.matches(item, key));
      const entering = this.items.filter((item) => item.hidden && this.matches(item, key));
      const staying = this.items.filter((item) => !item.hidden && this.matches(item, key));
      const count = this.items.filter((item) => this.matches(item, key)).length;
      if (this.status) {
        this.status.textContent = this.dataset.status.replace('[count]', count).replace('[total]', this.items.length);
      }

      const motion =
        document.documentElement.classList.contains('stay-motion') &&
        !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const style = getComputedStyle(document.documentElement);
      const duration = parseFloat(style.getPropertyValue('--stay-motion-duration-ui')) || 600;
      const easing = style.getPropertyValue('--stay-motion-ease').trim() || 'ease-out';
      const distance = style.getPropertyValue('--stay-motion-distance').trim() || '1.6rem';

      // Shown ingredients count as revealed, so the scroll reveal doesn't run on them again
      entering.forEach((item) => item.classList.add('is-revealed', 'is-settled'));

      if (!motion) {
        leaving.forEach((item) => (item.hidden = true));
        entering.forEach((item) => (item.hidden = false));
        if (key === 'all') this.list.style.minHeight = '';
        return;
      }

      const before = new Map(staying.map((item) => [item, item.getBoundingClientRect()]));
      await Promise.all(
        leaving.map(
          (item) => item.animate([{ opacity: 1 }, { opacity: 0 }], { duration: duration / 2, easing, fill: 'forwards' }).finished
        )
      ).catch(() => {});
      if (run !== this.run) return;

      leaving.forEach((item) => {
        item.hidden = true;
        item.getAnimations().forEach((animation) => animation.cancel());
      });
      entering.forEach((item) => (item.hidden = false));
      if (key === 'all') this.list.style.minHeight = '';

      staying.forEach((item) => {
        const from = before.get(item);
        const to = item.getBoundingClientRect();
        const dx = from.left - to.left;
        const dy = from.top - to.top;
        if (dx || dy) {
          item.animate([{ transform: `translate(${dx}px, ${dy}px)` }, { transform: 'none' }], { duration, easing });
        }
      });
      entering.forEach((item, index) => {
        item.animate(
          [
            { opacity: 0, transform: `translateY(${distance})` },
            { opacity: 1, transform: 'none' },
          ],
          { duration, easing, delay: Math.min(index, 6) * 60, fill: 'backwards' }
        );
      });
    }
  }

  customElements.define('formula-filter', FormulaFilter);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      // Keep --header-height in sync; the transparent header's overlap depends on it.
      this.resizeObserver = new ResizeObserver(this.setHeaderHeight);
      this.resizeObserver.observe(this.header);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.resizeObserver.disconnect();
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  // The account icon (Shopify's <shopify-account>) focuses a button inside its shadow root, so the host
  // never matches :focus-visible and the icons' focus state never showed. Mirror the inner button's
  // keyboard focus as a class (a mouse click doesn't set it).
  document.addEventListener('focusin', (event) => {
    const account = event.target instanceof HTMLElement && event.target.closest('shopify-account');
    if (!account) return;
    const inner = account.shadowRoot?.activeElement;
    account.classList.toggle('is-focus-visible', Boolean(inner?.matches(':focus-visible')));
  });
  document.addEventListener('focusout', (event) => {
    if (event.target instanceof HTMLElement && event.target.matches('shopify-account')) {
      event.target.classList.remove('is-focus-visible');
    }
  });

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-video"] && !Shopify.designMode) return;
  try {
    
  // No play / pause button (client, 2026-10-08): with reduced motion the video never starts and the poster
  // stays (WCAG 2.2.2); otherwise it plays muted on loop, and pauses once the page has covered it.
  class HeroVideo extends HTMLElement {
    connectedCallback() {
      this.desktopVideo = this.querySelector('.hero-video__video--desktop');
      this.mobileVideo = this.querySelector('.hero-video__video--mobile');
      if (!this.desktopVideo) return;

      this.mobileQuery = window.matchMedia('(max-width: 749px)');
      this.reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

      this.onMediaChange = this.update.bind(this);
      this.mobileQuery.addEventListener('change', this.onMediaChange);
      this.reducedMotionQuery.addEventListener('change', this.onMediaChange);

      // With "Next sections slide over the hero" the hero stays behind the page: once it's fully covered
      // (scrolled past its own height) the video pauses, and plays again on the way back
      this.covered = false;
      if (this.classList.contains('hero-video--takeover')) {
        this.onScroll = () => {
          if (this.scrollFrame) return;
          this.scrollFrame = requestAnimationFrame(() => {
            this.scrollFrame = null;
            const covered = window.scrollY >= this.offsetHeight;
            if (covered === this.covered) return;
            this.covered = covered;
            this.update();
          });
        };
        window.addEventListener('scroll', this.onScroll, { passive: true });
      }

      this.update();
    }

    disconnectedCallback() {
      this.mobileQuery?.removeEventListener('change', this.onMediaChange);
      this.reducedMotionQuery?.removeEventListener('change', this.onMediaChange);
      if (this.onScroll) window.removeEventListener('scroll', this.onScroll);
    }

    get activeVideo() {
      return this.mobileVideo && this.mobileQuery.matches ? this.mobileVideo : this.desktopVideo;
    }

    update() {
      const active = this.activeVideo;

      [this.desktopVideo, this.mobileVideo].forEach((video) => {
        if (video && video !== active) video.pause();
      });

      if (this.reducedMotionQuery.matches || this.covered) {
        active.pause();
      } else {
        active.preload = 'auto';
        // Autoplay can be blocked (e.g. low power mode); the poster under the video then stays
        active.play().catch(() => {});
      }
    }
  }

  customElements.define('hero-video', HeroVideo);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ugc-stories"] && !Shopify.designMode) return;
  try {
    
  // A story card with a video: the photo shows until the play button is pressed, then the video
  // plays muted over it; the same button pauses it.
  class UgcStory extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      this.button = this.querySelector('.ugc-stories__play');
      if (!this.video || !this.button) return;
      this.video.muted = true;
      this.button.addEventListener('click', () => (this.video.paused ? this.play() : this.pause()));
    }

    play() {
      this.video.play();
      this.classList.add('is-playing');
      this.setState(true);
    }

    pause() {
      this.video.pause();
      this.setState(false);
    }

    setState(playing) {
      this.button.setAttribute('aria-pressed', String(playing));
      this.button.setAttribute('aria-label', playing ? this.button.dataset.labelPause : this.button.dataset.labelPlay);
    }
  }

  customElements.define('ugc-story', UgcStory);

  } catch(e) { console.error(e); }
})();
})();
